__turbopack_context__.v({
  "className": "noto_sans_thai_f863a5a9-module__4VdIUq__className",
  "variable": "noto_sans_thai_f863a5a9-module__4VdIUq__variable",
});
